<template>
	<div class="table">
		<el-table
			border
			ref="multipleTable"
			id="exportTab"
			:data="tableData"
			:header-cell-style="{ 'text-align': 'center' }"
			height="60vh"
			:cell-style="{ 'text-align': 'center' }"
			tooltip-effect="dark"
			style="width: 100%"
			@selection-change="handleSelectionChange"
			v-loading="loading"
		>
			<!-- <el-table-column type="selection" width="55"> </el-table-column> -->
			<el-table-column prop="id" label="id" width="65px"> </el-table-column>
			<el-table-column
				prop="title"
				label="资讯标题"
				min-width="200px"
				show-overflow-tooltip
			>
				<template slot-scope="scope">
					<span class="source_top_span" v-if="scope.row.is_top == 1">
						置顶
					</span>
					<span class="source_title_span">
						{{ getSourceType(scope.row.title) }}
					</span>
				</template>
			</el-table-column>
			<el-table-column label="类型" width="50px">
				<template slot-scope="scope">
					<span v-if="scope.row.type == 1">文章</span>
					<span v-if="scope.row.type == 2">快讯</span>
					<span v-if="scope.row.type == 5">专栏</span>
					<span v-if="scope.row.type == 7">活动</span>
				</template>
			</el-table-column>
			<!-- <el-table-column prop="label_name" label="标签" min-width="15%">
			</el-table-column> -->

			<el-table-column
				v-if="from == 1"
				prop="source_type"
				label="来源"
				width="110px"
			>
				<template slot-scope="scope">
					<span class="source_type_span">
						{{ getSourceType(scope.row.source_type) }}
					</span>
				</template>
			</el-table-column>
			<el-table-column
				prop="nickname"
				label="作者"
				width="120px"
				v-if="from == 0 || from == 3"
			>
			</el-table-column>
			<el-table-column
				prop="edit_type"
				label="编辑类型"
				width="80px"
				v-if="from == 0 || from == 3"
			>
				<template slot-scope="scope">
					<span v-if="scope.row.edit_type == 1">PR</span>
					<span v-if="scope.row.edit_type == 2">人工原创</span>
					<span v-if="scope.row.edit_type == 6">AI原创</span>
					<span v-if="scope.row.edit_type == 3">翻译</span>
					<span v-if="scope.row.edit_type == 4">转载</span>
					<span v-if="scope.row.edit_type == 5">审核</span>
					<span v-if="scope.row.edit_type == 7">AI转载</span>
				</template>
			</el-table-column>
			<el-table-column
				prop="adminName"
				label="操作人"
				width="70px"
				v-if="from == 0 || from == 3"
			>
			</el-table-column>
			<el-table-column
				prop="visits_num"
				label="阅读量"
				width="60px"
				v-if="from == 0"
			>
			</el-table-column>
			<el-table-column prop="release_time" label="发布时间" width="150px">
			</el-table-column>
			<el-table-column label="状态" width="60px">
				<template slot-scope="scope">
					<span v-if="scope.row.status == 1">已发布</span>
					<span v-else>草稿</span>
				</template>
			</el-table-column>
			<el-table-column label="链接" width="95px">
				<template slot-scope="scope">
					<span class="pointer margin_left_10" @click="showPreView(scope.row)">
						预览
					</span>
					<span class="pointer margin_left_10" @click="copyUrl(scope.row)">
						复制
					</span>
				</template>
			</el-table-column>
			<el-table-column label="操作" width="300px">
				<template slot-scope="scope">
					<span class="pointer margin_left_10" @click="toEditNew(scope.row)">
						修改
					</span>
					<span class="pointer margin_left_10" @click="addTgPush(scope.row)">
						tg推送
					</span>
					<span class="pointer margin_left_10" @click="push(scope.row)">
						{{ scope.row.is_push == 1 ? "已推送" : "推送" }}
					</span>
					<span
						class="pointer margin_left_10"
						@click="disInformation(scope.row)"
					>
						{{ scope.row.status == 1 ? "屏蔽" : "取消屏蔽" }}
					</span>
					<span class="pointer margin_left_10" @click="toTop(scope.row)">
						{{ scope.row.is_top == 1 ? "取消置顶" : "置顶" }}
					</span>

					<span class="pointer margin_left_10" @click="toDelete(scope.row)">
						删除
					</span>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
import {
	disInformation,
	delInformation,
	topInformation,
	informationHome,
	addInformation,
	addTgPush,
} from "@/api/article";
import { addAliPush } from "@/api/user";
import clipboard from "clipboard";
import ChineseConv from "chinese-s2t";

export default {
	props: ["tableData", "from", "loading"],
	name: "",
	data() {
		return {
			value: true,
			sourceTypeMap: {
				50: "BlockBeats",
				51: "Odaily",
				52: "Bitpush",
				53: "TechFlow",
				54: "PANews",
				55: "MLion",
				56: "金十",
				57: "Followin",
				15: "OKX",
				16: "Bitget",
				17: "Stock-BBX",
				18: "MyToken",
				40: "BBX",
				10: "BlockBeats",
				11: "TechFlow",
				12: "PANews",
				13: "Bitpush",
				14: "TechFlow Research",
				19: "ChainCatcher",
				20: "BlockTempo",
				21: "吴说",
				22: "MarsBit",
				70: "CoinFound",
				81: "AIMPACT",
			},
		};
	},
	methods: {
		getSourceType(type) {
			var sourceType = this.sourceTypeMap[type];
			if (!sourceType) {
				sourceType = type;
			}
			return sourceType;
		},
		disInformation(row) {
			disInformation({ id: row.id }).then((res) => {
				if (res.code == 200) {
					console.log(this.$parent);
					this.$parent.$parent.getDataList();
				}
			});
		},
		addTgPush(row) {
			if (row.allow_tgpush == 1) {
				addTgPush({
					id: row.id,
					title: row.title,
					content: row.content,
					prohibit_tran: row.prohibit_tran,
				}).then((res) => {
					if (res.code == 200) {
						console.log(this.$parent);
						this.$parent.$parent.getDataList();
						this.$message({ message: "推送成功", type: "success" });
					} else {
						this.$message({ message: "推送失败", type: "info" });
					}
				});
			} else {
				this.$message({ message: "该资讯不允许推送tg", type: "info" });
			}
		},
		informationHome(row) {
			informationHome({ id: row.id }).then((res) => {
				if (res.code == 200) {
					console.log(this.$parent);
					this.$parent.$parent.getDataList();
				}
			});
		},
		toggleSelection(rows) {
			if (rows) {
				rows.forEach((row) => {
					this.$refs.multipleTable.toggleRowSelection(row);
				});
			} else {
				this.$refs.multipleTable.clearSelection();
			}
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		toEdit(row) {
			// const routeData = this.$router.resolve({
			// 	path: "/message/addmessage",
			// 	query: { id: row.id, type: "edit" },
			// });
			// window.open(routeData.href, "_blank");

			this.$router.push({
				path: "/message/addmessage",
				query: { id: row.id, type: "edit" },
			});
		},
		toEditNew(row) {
			this.$router.push({
				path: "/message/addmessage_new",
				query: { id: row.id, type: "edit" },
			});
		},

		push(row) {
			const that = this;
			if (row.is_push == 1) {
				this.$message({ message: "该资讯已推送", type: "error" });
				return;
			}
			this.$confirm("此操作将推送该条资讯, 是否继续?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(() => {
					if (row.type == 2) {
						// 快讯
						var pushData = {
							title: "ME News",
							desc: row.title,
							type: 2,
							object_id: Number(row.id),
						};
						addAliPush(pushData)
							.then((res) => {
								if (res.code == 200) {
									this.$message({ message: "推送成功", type: "success" });
									this.examine(row);
								} else {
									this.$message({ message: "推送失败", type: "info" });
								}
							})
							.catch((error) => {});
					} else {
						// 非快讯
						var pushData = {
							title: row.title,
							desc:
								row.illustrate != null && row.illustrate != ""
									? row.illustrate
									: row.content,
							type: 1,
							object_id: Number(row.id),
						};
						addAliPush(pushData)
							.then((res) => {
								if (res.code == 200) {
									this.$message({ message: "推送成功", type: "success" });
									this.examine(row);
								} else {
									this.$message({ message: "推送失败", type: "info" });
								}
							})
							.catch((error) => {
								this.$message.error(error.message);
							});
					}
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消推送",
					});
				});
		},
		examine(row) {
			let that = this;
			let formData = {
				id: row.id,
				is_push: 1,
				type: row.type,
				score: 1,
				release_time: row.release_time,
				content: row.content,
			};
			addInformation(formData)
				.then((res) => {
					if (res.code == 200) {
						location.reload();
					} else {
					}
				})
				.catch((error) => {});
		},
		showPreView(row) {
			let url = "https://me.news/contents/" + row.id;
			if (row.type == 2) {
				url = "https://me.news/news/" + row.id;
			}
			window.open(url, "预览");
		},
		copyUrl(row) {
			let msg = "https://me.news/contents/" + row.id;
			if (row.type == 2) {
				msg = "https://me.news/news/" + row.id;
			}
			clipboard.copy(msg);
			this.$message({ message: "复制成功", type: "success" });
		},
		toDelete(row) {
			this.$confirm("此操作将删除该条资讯, 是否继续?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(() => {
					delInformation({ id: row.id }).then((res) => {
						if (res.code == 200) {
							this.$message({
								type: "success",
								message: "删除成功!",
							});
							this.$parent.$parent.getDataList();
						}
					});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消删除",
					});
				});
		},

		toTop(row) {
			this.$confirm("此操作将更改资讯的置顶状态, 是否继续?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(() => {
					this.$parent.$parent.loading = true;
					topInformation({ id: row.id, is_top: row.is_top == 1 ? 0 : 1 })
						.then((res) => {
							if (res.code == 200) {
								this.$message({
									type: "success",
									message: "操作成功!",
								});
								this.$parent.$parent.getDataList();
							}
						})
						.finally(() => {
							this.$parent.$parent.loading = false;
						});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消操作",
					});
				});
		},
	},
};
</script>

<style scoped>
.source_type_span {
	text-transform: capitalize;
}

.source_top_span {
	display: inline-block;
	padding: 2px 5px;
	border-radius: 3px;
	text-align: center;
	color: #fff;
	background: #ff4d4f;
}
</style>
